import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/__auth/processes/$processInstanceId/history/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/processes/$processInstanceId/history/details',
            params: { processInstanceId: params.processInstanceId },
        });
    },
});
